import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

import s from './infoPopUp.scss';
import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { reportEditorClick } from '../../utils/bi';
import { CustomModal } from '../CustomModal';

export const InfoPopUp: FC<{ isMobile?: boolean; dataHook?: string }> = ({ isMobile, dataHook }) => {
  const { isInfoShown, setIsInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { t } = useTranslation();

  const onEditorClick = () => {
    reportEditorClick({ origin: 'viewer_more' });
  };

  return (
    <CustomModal isOpen={isInfoShown} onClose={() => setIsInfoShown(false)}>
      <div className={s.modalContent} data-hook={dataHook}>
        <h1 className={s.modalTitle}>{t('template.viewer.info.title', { title: template.title })}</h1>
        <div className={s.modalFeature}>
          <h3 className={s.modalSubtitle}>{t('template.viewer.info.goodFor')}</h3>
          <p className={s.modalRunningText}>{template.goodFor}</p>
        </div>
        <div className={s.modalFeature}>
          <h3 className={s.modalSubtitle}>{t('template.viewer.info.description')}</h3>
          <p className={s.modalRunningText}>{template.description}</p>
        </div>
        {isMobile ? (
          <>
            <hr className={s.modalDivider} />
            <span className={s.modalMobileDescription}> {t('template.viewer.info.desktop.only.notice')}</span>
          </>
        ) : (
          <a href={template.editorUrl} className={s.modalBtn} target="_blank" onClick={onEditorClick} rel="noreferrer">
            {t('template.viewer.info.edit.button')}
          </a>
        )}
      </div>
    </CustomModal>
  );
};
